<div class="row mrgn-bttm-lg">
    <div class="col-md-12">
        <div>
        <h3 class="text-center" [innerHtml]="termsAndConditions.title"></h3>
        <p [innerHtml]="termsAndConditions.terms.paragraph1"></p>
        <p [innerHtml]="termsAndConditions.terms.paragraph2"></p>
        <p [innerHtml]="termsAndConditions.terms.paragraph3"></p>
        <p [innerHtml]="termsAndConditions.terms.paragraph4"></p>
        <h5>
            <u>{{ termsAndConditions.terms.terms_title1 }}</u>
        </h5>
        <ul>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item1"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item2"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item3"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item4"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item5"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item6"></li>
        </ul>
        <h5>
            <u>{{ termsAndConditions.terms.terms_title2 }}</u>
        </h5>
        <p [innerHtml]="termsAndConditions.terms.terms_title2_paragraph1"></p>
        <ol type="1">
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item1"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item2"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item3"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item4"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item5"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item6"></li>
        </ol>
        </div>
    </div>
</div>